import { object } from 'prop-types';
import React from 'react';
import styled, { withTheme } from 'styled-components';

import Tooltip from 'ravenjs/lib/Tooltip';
import { getThemeProps } from 'ravenjs/utils/theme';

import { ICONS_TOOLTIP_TEXTS } from 'constants/navigation';
import { AskHRExpertIcon } from 'components/Icons';
import { DEFAULT_COLORS } from 'constants/colors';

const AskHRExpertContainer = styled.div`
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    ${({ theme }) => theme.media.up('md')`
        margin: 0 0 0 0.825rem;
    `};
`;

function AskHRExpert({ theme }) {
    return (
        <Tooltip
            content={ICONS_TOOLTIP_TEXTS.ASK_AN_EXPERT}
            padding="4px 16px"
            margin={0}
            arrowSize={5}
            placement="top"
            borderRadius="5px"
        >
            <AskHRExpertContainer>
                <AskHRExpertIcon
                    fill={getThemeProps('NavItem.styles.color', DEFAULT_COLORS.BLACK, {
                        theme,
                    })}
                    width="32px"
                    height="32px"
                    cursor="pointer"
                    isActive
                    onClick={() => {
                        window.location.href = '/my-cases/create';
                    }}
                />
            </AskHRExpertContainer>
        </Tooltip>
    );
}

AskHRExpert.propTypes = {
    theme: object.isRequired,
};

export { AskHRExpert as AskHRExpertUnwrapped };
export default withTheme(AskHRExpert);
